import {useSelector} from 'react-redux'
import {useGenericPostRequestQuery} from '../redux/commonRTK'
import {apiConstants} from '../common/constants'
import {findWalletBalance} from '../helpers/UtilityHelper'

export function useGetBillingData() {
  const selectedMerchantId = useSelector((state) => state.user.selectedUserId)
  const userInfoMerchantId = useSelector((state) => state.user.userInfo.merchant.id)

  const merchantId = selectedMerchantId || userInfoMerchantId

  const {data: merchant} = useGenericPostRequestQuery({
    type: 'GET',
    url: `${apiConstants.GET_ALL_WALLET}`,
    data: {
      merchantId,
    },
  })

  const walletDetails = merchant ? findWalletBalance(merchant) : {}

  return {
    walletDetails,
    merchantId,
  }
}
